var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DashboardLayout',[_c('HelloUser',{attrs:{"user":_vm.user}}),_c('DashboardBody',{attrs:{"user":_vm.user,"usdValue":_vm.usdValue,"isUsd":_vm.isUsd,"loading":_vm.loading,"code":_vm.code,"sites":_vm.sites}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }